import React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

export const SapCtaBanner: React.FC<Props> = ({
	headingKey,
	buttonKey,
	sourceLocation,
	onButtonClick,
	className,
	buttonClassName,
	containerQa,
	buttonQa,
}) => (
	<div className={cn('bg-gradient-background-dark-3 rounded-xl', className)} data-qa={containerQa}>
		<Text as="h2" variant="heading" size="small" className="text-typography-inverse-strong">
			<TypedTranslate value={headingKey} />
		</Text>

		<Button
			variant="primary"
			className={buttonClassName}
			as="a"
			href={`/start-a-petition/intro?source_location=${encodeURIComponent(sourceLocation)}`}
			data-qa={buttonQa}
			onClick={onButtonClick}
		>
			<TypedTranslate value={buttonKey} />
		</Button>
	</div>
);

type Props = Readonly<{
	headingKey: TranslationKey;
	buttonKey: TranslationKey;
	sourceLocation: string;
	onButtonClick?: () => void;
	className?: string;
	buttonClassName?: string;
	containerQa?: string;
	buttonQa?: string;
}>;
